export const Achievements = [
    {
        title : "Hack-A-Day",
        achievement_name : "Winner of ACM East India Hackathon (Hack-A-Day)",
        images : "assets/images/hackaday.jpg",
        githubLink : "www.github.com/shawavisek35"
    },
    {
        title : "Zoo Hackathon",
        achievement_name : "Finalist of Kolkata Zoo Hackathon",
        images : "assets/images/zoohackathon.jpg",
        githubLink : ""
    },
    {
        title : "Robo War",
        achievement_name : "2nd Runner up in the robowar event held at FIEM college",
        images : "assets/images/robowar.jpg",
        githubLink : ""
    },
    {
        title : "Robo Race",
        achievement_name : "1st Runner up in the roborace event held at JIS college",
        images : "assets/images/roborace.jpg",
        githubLink : ""
    },
    {
        title : "Publication",
        achievement_name : "Co-Authored on a paper published in ICDCIT-KIIT(PIC)-2020 Titled : Indoor Air Pollution Controlling Device.",
        images : "assets/images/kiit2.jpg",
        githubLink : ""
    }
]

export const Activity = [
    {
        job : "Leaded a local chapter of Google Developer Student Clubs in my campus."
    },
    {
        job : "Actively take part in different Hackathons."
    },
    {
        job : "Active member of the tech-group of my college."
    },
    {
        job : "Active member of the Microsoft Student's Partner Community of my college."
    }
]
